<script lang="ts">
    import type { Vector } from "./Vector";

    export let fromPosition: Vector;

    export let toPosition: Vector;

    function handleClick() {
        console.log('click transition')
    }
</script>

<line 
    on:click={handleClick}
    x1={fromPosition.x}
    y1={fromPosition.y}
    x2={toPosition.x}
    y2={toPosition.y}
    stroke="black"
    marker-end="url(#markerArrow)"
/>

<style>
    /* Ohne pointer-events: none kann es passieren, dass beim Erstellen einer neuen Transition ein Click-Event
       auf die Linie gemacht wird, das eigentlich für den darunterliegenden State gedacht war.
       Bei dem State kommt das Click-Event dann nicht an. */
    line {
        pointer-events: none;
    }
</style>